"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _ui = require("@alycecom/ui");

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var spacing = _ref.spacing;
  return {
    root: {
      margin: spacing(2),
      padding: spacing(3)
    },
    subTitle: {
      fontSize: '12px',
      textTransform: 'uppercase',
      fontWeight: 'bold',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }
  };
});

var ContactDetailsCard = function ContactDetailsCard(_ref2) {
  var title = _ref2.title,
      render = _ref2.render,
      isLoading = _ref2.isLoading;
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_material.Paper, {
    className: classes.root,
    elevation: 1
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: classes.subTitle,
    variant: "subtitle2"
  }, isLoading ? /*#__PURE__*/_react.default.createElement(_ui.LoadingLabel, null) : title), render());
};

ContactDetailsCard.propTypes = {
  title: _propTypes.default.string,
  render: _propTypes.default.func.isRequired,
  isLoading: _propTypes.default.bool
};
ContactDetailsCard.defaultProps = {
  title: '',
  isLoading: false
};
var _default = ContactDetailsCard;
exports.default = _default;